import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useMutation, useQuery } from "@apollo/client";
import { GET_ORDER_FOR_PAYMENT } from "../graphql/Query/Order.js";
import { capitalizeFirstLetter } from "../OrderPage/AllOrders.js";
import SpinLoader from "../components/SpinLoader.js";
import moment from "moment";
import * as XLSX from 'xlsx';
import { Link, useLocation } from "react-router-dom";
import NoDataFound from "../components/NoDataFound.js";
import { FiDownload } from "react-icons/fi";
import CustomPagination from "../components/Pagination.js";
import AdminHeader from "./AdminHeader.js";
import { Dialog, DialogPanel } from "@headlessui/react";
import { UPDATE_BULK_ORDER_STATUS, UPDATE_TODAY_PAYMENT_STATUS } from "../graphql/Mutation/Ordre.js";
import { warehouseOptions } from "../DomesticSellerOrder/AllOrderSeller.js";
import { toast } from "react-toastify";
import { CREATE_UPDATE_SELLER_TRANSACTION } from "../graphql/Query/SellerTransaction.js";
import Table from "../components/Table/index.jsx";
import { customerPendingPaymentColumns } from "../components/Constant/index.js";
const AdminSingleCodPayment = () => {
    const location = useLocation();
    const [activeTab, setActiveTab] = useState("Pending Payment");
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [filter, setFilter] = useState('');
    const [orderData, setOrderData] = useState([]);
    const [toDate, setToDate] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [searchUser, setSearchUser] = useState('');
    const [cod_payment_status, setcod_payment_status] = useState('');
    const [filterOrder, setFilterOrder] = useState('');
    const [awbNumber, setawbNumber] = useState('');
    const [orderStatus, setorderStatus] = useState('');
    const [updateBulkOrderStatus] = useMutation(UPDATE_BULK_ORDER_STATUS);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedDayRange, setSelectedDayRange] = useState(""); // Logical value
    const [displayedDayRange, setDisplayedDayRange] = useState({ label: "All", value: "" }); // Displayed value
    const [createSellerPaymentTransaction] = useMutation(CREATE_UPDATE_SELLER_TRANSACTION);
    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);
    const { data: GetOrderOrder, loading, refetch } = useQuery(GET_ORDER_FOR_PAYMENT, {
        variables: {
            page: page,
            limit,
            "sort": {
                "key": "createdAt",
                "type": -1
            },
            "filter": filter.trim(),
            "from": fromDate,
            "to": toDate,
            "orderStatus": orderStatus,
            "cod_payment_status": cod_payment_status,
            customerId: location?.state?.customerId,
            dayRange: selectedDayRange
        },
        fetchPolicy: "cache-and-network"
    })
    // console.log('✌️GetOrderOrder ============', GetOrderOrder);
    const fromDateChange = (e) => {
        setFromDate(e.target.value);
    }

    const toDateChange = (e) => {
        setToDate(e.target.value);
    }
    const handleSearch = (e, awb) => {
        if (awb === 'orderId') {
            setFilterOrder(e.target.value);
            setFilter(e.target.value)
        } else if (awb === 'awbNumber') {
            setFilter(e.target.value);
            setawbNumber(e.target.value)
        } else {
            setFilter(e.target.value);
        }
        setPage(0);

    }
    useEffect(() => {
        if (GetOrderOrder?.getCustomerPendingPaymentOrder?.data) {
            setOrderData(GetOrderOrder?.getCustomerPendingPaymentOrder?.data);
        }
    }, [GetOrderOrder]);

    const handleTabClick = (tab) => {
        setActiveTab(tab);
        if (tab === 'Pending Payment') {
            setcod_payment_status('pending')
        } else if (tab === 'Success Payment') {
            setcod_payment_status('success')
        }
    };

    const resetData = () => {
        setPage(0);
        setToDate("");
        setFromDate("");
        setFilter("");
        setSearchUser("");
        setawbNumber("");
        setFilterOrder("");
        setorderStatus('');
        setSelectedDayRange("")
        setDisplayedDayRange({ label: "All", value: "" }); // Display "All" in the Select dropdown
    }
    const handlePagination = (page) => {
        setPage(page?.selected);
    };

    const transformDataForExport = (data) => {
        return data?.map((shipment, index) => {
            const fullAddress = shipment?.deliveryAddress?.address1 || '';
            const city = shipment?.deliveryAddress?.city || '';
            const state = shipment?.deliveryAddress?.stateId?.name || '';
            const zipCode = shipment?.deliveryAddress?.zipCode || '';

            return {
                No: index,
                "Shipment Date": shipment?.createdAt ? moment(shipment?.createdAt).format('DD/MM/YYYY') : "-",
                "Delivered Date": shipment?.delivery_order_Date ? moment(shipment?.delivery_order_Date).format('DD/MM/YYYY') : "-",
                AWB: shipment?.awb_number ? shipment?.awb_number : "-",
                "Order ID": shipment?.order_id ? shipment?.order_id : "-",
                "Order Number": shipment?.order_number ? shipment?.order_number : "-",
                "Payment Type": shipment?.payment_type ? shipment?.payment_type : "-",
                "Receiver Name (To)": shipment?.deliveryAddress?.name,
                State: state,
                Address: fullAddress,
                City: city,
                "Zip Code": zipCode,
                // "phone":demoo,
                "Weight (Kg)": shipment?.package_weight,
                Status: shipment?.status,
                Product: shipment?.ProductName,
                "COD Collectable Rs.": shipment?.payment_type === 'cod' ? `₹${shipment?.ProductPrice}` : "-",
                "COD Collection Rs.": `${shipment?.codCollectableValue}`,
                "RTO Charges": `${shipment?.rto_order_charge || 0}`,
                "Shipment Charge": `₹${shipment?.order_amount}`,
                "Total Amount": `${shipment?.final_order_amount || 0}`,
                "Total Receivable Amount": `${shipment?.net_receivable_amount || 0}`,
                "payment Status": `${shipment?.cod_payment_status || '-'}`
            };
        });
    };

    const downloadExcel = () => {
        if (!GetOrderOrder?.getCustomerPendingPaymentOrder?.data?.length) return;

        // Transform data
        const transformedData = transformDataForExport(GetOrderOrder?.getCustomerPendingPaymentOrder?.data);

        // Create a worksheet
        const worksheet = XLSX.utils.json_to_sheet(transformedData);

        // Create a workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Shipments");

        // Generate and download the Excel file
        XLSX.writeFile(workbook, "shipments.xlsx");
    };

    // const handleBulkUpdate = async () => {
    //     // const orderIds = 
    //     const cod_payment_status = "success"; // Example status, adjust as needed

    //     try {
    //         const response = await updateBulkOrderStatus({
    //             variables: { input: { orderIds, cod_payment_status } },
    //         });

    //         // console.log('✌️response --->', response);
    //         if (response?.data?.updateTodayOpenCloseStatusBulk) {
    //             const res = await createSellerPaymentTransaction({
    //                 variables: { input: { customerId: location?.state?.customerId, orderIds: orderIds, cod_payment_status: cod_payment_status, paymentAmount: calculateTotalAmount().toFixed(2), totalShipment: selectedCheckboxes?.length } },
    //             });
    //             console.log('✌️res --->', res);
    //             toast.success("status update successful!");
    //             refetch();
    //             // Optionally refetch data here
    //         } else {
    //             toast.error("status update failed")
    //         }
    //     } catch (error) {
    //         console.error("Error during bulk update:", error);
    //         // alert("An error occurred while updating orders");
    //     }
    // };
    return (
        <>
            <AdminHeader />
            <div className="mx-auto max-w-auto px-4 sm:px-6 lg:px-8">
                {/* Header Section */}
                <div className="bg-slate-50 border border-slate-300 p-6 rounded-lg my-6">
                    <div className="flex flex-col md:flex-row justify-between items-center w-full">
                        <h1 className="text-lg font-bold text-gray-800">
                            {location?.state?.email}
                        </h1>
                        <button
                            onClick={downloadExcel}
                            className="flex items-center px-4 py-1 bg-slate-800 text-white rounded-lg hover:bg-slate-900 transition duration-300 focus:outline-none focus:ring-2 focus:ring-blue-400"
                        >
                            <FiDownload className="mr-2 text-lg sm:text-xl " />
                            Export
                        </button>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-4">
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">Search Anything</label>
                            <input
                                type="text"
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                                placeholder="Type here..."
                                value={searchUser}
                                onChange={(e) => { setSearchUser(e.target.value); handleSearch(e); }}
                            />
                        </div>


                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">AWB No.</label>
                            <input
                                type="text"
                                value={awbNumber}
                                onChange={(e) => { setawbNumber(e.target.value); handleSearch(e, 'awbNumber'); }}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                                placeholder="Enter AWB No."
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">Shipment IDs</label>
                            <input
                                type="text"
                                value={filterOrder}
                                onChange={(e) => { setFilterOrder(e.target.value); handleSearch(e, 'orderId') }}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                                placeholder="Enter Shipment ID"
                            />
                        </div>

                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">From Date</label>
                            <input
                                type="date"
                                value={fromDate}
                                onChange={fromDateChange}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">To Date</label>
                            <input
                                type="date"
                                value={toDate}
                                onChange={toDateChange}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                            />
                        </div>

                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-1">Date Range</label>
                            <Select
                                options={warehouseOptions}
                                // defaultValue={channelOptions[0]}
                                className="w-full"
                                value={displayedDayRange} // Controls the displayed value
                                onChange={(selectedOption) => {
                                    setSelectedDayRange(selectedOption?.value); // Update logical value
                                    setDisplayedDayRange(selectedOption); // Update displayed value

                                }}
                                classNamePrefix="react-select"
                                styles={{
                                    control: (base, state) => ({
                                        ...base,
                                        borderColor: state.isFocused ? '#64748B' : '#64748B',
                                        '&:hover': { borderColor: '#64748B' },
                                        boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                        borderRadius: '0.375rem',
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        color: '#000000',
                                        fontSize: '0.875rem',
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                        color: state.isSelected ? 'white' : '#000000',
                                        fontSize: '0.875rem',
                                        '&:hover': {
                                            backgroundColor: '#f0f0f0',
                                            fontSize: '0.875rem',
                                            color: '#000000',
                                        }
                                    }),
                                    placeholder: (base) => ({
                                        ...base,
                                        fontSize: '0.875rem',
                                        color: '#A3AAB5',

                                    }),
                                }}
                            />
                        </div>


                        {/* <div className="flex flex-col">
                        <label className="text-sm text-gray-700 mb-1">Warehouse</label>
                        <Select
                            options={warehouseOptions}
                            defaultValue={warehouseOptions[0]}
                            className="w-full"
                            classNamePrefix="react-select"
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? '#64748B' : '#64748B',
                                    '&:hover': { borderColor: '#64748B' },
                                    boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                    borderRadius: '0.375rem',
                                }),
                                singleValue: (base) => ({
                                    ...base,
                                    color: '#000000',
                                }),
                                option: (base, state) => ({
                                    ...base,
                                    backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                    color: state.isSelected ? 'white' : '#000000',
                                    '&:hover': {
                                        backgroundColor: '#f0f0f0',
                                        color: '#000000',
                                    }
                                }),
                                placeholder: (base) => ({
                                    ...base,
                                    fontSize: '14px',
                                    color: '#A3AAB5',
                                }),
                            }}
                        />
                    </div> */}




                        <div className="mt-6 flex gap-4">
                            <button className="bg-slate-500 text-white px-4 py-1 rounded-lg text-sm hover:bg-slate-600" onClick={resetData}>
                                Clear
                            </button>
                        </div>
                    </div>

                </div>


                {/* Tab Section */}
                <div className="bg-white px-4 py-3 border-s-0 border-r-0 border-t border-b border-slate-300 mb-4">
                    <div className="flex flex-wrap gap-4">
                        {[
                            "Pending Payment",
                            "Success Payment",
                        ].map((tab) => (
                            <button
                                key={tab}
                                className={`font-semibold border-b-2 px-2 py-1 text-sm ${activeTab === tab
                                    ? "text-blue-600 border-blue-600"
                                    : "text-gray-600 border-transparent hover:text-blue-600"
                                    }`}
                                onClick={() => handleTabClick(tab)}
                            >
                                {tab}
                                {/* {tab !== "All" && `(${GetOrderOrder?.getPaymentOrders?.count})`} */}
                            </button>
                        ))}
                    </div>
                </div>
                <div className="flex flex-col md:flex-row items-center justify-start  w-full p-4 sm:p-2">
                    <div className="flex flex-col md:flex-row items-center">
                        <h2 className="my-7 font-bold text-gray-800">
                            {location?.state?.email}

                        </h2>
                    </div>
                    {/* <div className="min-h-screen flex items-center justify-center bg-slate-100"> */}
                    {/* Open Modal Button */}
                    <div className="mt-4 md:mt-0 ms-4">
                        <button
                            onClick={openModal}
                            className="px-4 py-2 bg-black text-white rounded hover:bg-slate-800 transition"
                        >
                            Open Modal
                        </button>
                        <Dialog open={isOpen} onClose={closeModal} className="relative z-50">
                            {/* Overlay */}
                            <div
                                transition
                                className="fixed inset-0 bg-black bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                            />

                            {/* Modal Content */}
                            <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
                                <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
                                    <DialogPanel
                                        transition
                                        className="relative transform w-full overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 lg:max-w-xl xl:max-w-2xl 2xl:max-w-7xl"
                                    >
                                        <div className="px-4 py-5 border-b border-gray-200 sm:px-6">
                                            <Dialog.Title className="text-lg font-medium leading-6 text-gray-900">
                                                Bank Account Details
                                            </Dialog.Title>
                                        </div>

                                        {/* Modal Body */}
                                        <div className="px-4 py-4 sm:px-6">

                                            <div className="mt-4">
                                                <p className="text-gray-700"><strong>Account Holder Name:</strong> John Doe</p>
                                                <p className="text-gray-700"><strong>Account Number:</strong> 1234567890</p>
                                                <p className="text-gray-700"><strong>Bank Name:</strong> Example Bank</p>
                                                <p className="text-gray-700"><strong>Branch:</strong> Main Street Branch</p>
                                                <p className="text-gray-700"><strong>IFSC Code:</strong> EXMP0001234</p>
                                                <p className="text-gray-700"><strong>Account Type:</strong> Savings</p>
                                            </div>
                                        </div>

                                        {/* Modal Footer */}
                                        <div className="px-4 py-3 sm:px-6 bg-slate-50 flex justify-end">
                                            <button
                                                onClick={closeModal}
                                                className="px-4 py-2 bg-slate-300 text-gray-800 rounded hover:bg-slate-400"
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </DialogPanel>
                                </div>
                            </div>
                        </Dialog>
                    </div>
                </div>

                {/* Shipment Table Section */}
                {/* {activeTab !== 'Success Payment' && <button
                    className="bg-black text-white px-4 py-2 mb-2 rounded border border-black hover:bg-white hover:text-black"
                    onClick={handleBulkUpdate}
                >
                    bulk Update COD Payment
                </button>} */}

                <div className="mt-2 bg-white p-4 border rounded-lg">
                    <Table
                        columns={customerPendingPaymentColumns}
                        data={orderData || []}
                        currentPage={page}
                        totalRecords={GetOrderOrder?.getCustomerPendingPaymentOrder?.count || 0}
                        limit={limit}
                        setLimit={setLimit}
                        setPage={setPage}
                        loading={loading}
                        // deleteData={DeleteProduct}
                        handlePagination={handlePagination}
                    // multiSelectRow={onSelectedRowsChange}
                    />
                </div>
            </div >
        </>
    )
}
export default AdminSingleCodPayment
